import { render, staticRenderFns } from "./CategoryListPage.vue?vue&type=template&id=21b15a20&scoped=true&"
import script from "./CategoryListPage.vue?vue&type=script&lang=js&"
export * from "./CategoryListPage.vue?vue&type=script&lang=js&"
import style0 from "./CategoryListPage.vue?vue&type=style&index=0&id=21b15a20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b15a20",
  null
  
)

export default component.exports